module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="custom-js-lock-list-container">\n    <h6>Action locked (not editable, nor deletable) due to use in the following Experiences:</h6>\n    <ul>\n        ';
 _.each(experiences, function (experience) { ;
__p += '\n            <li><a href="/#experience/' +
__e( experience.get('id') ) +
'/edit">' +
__e( experience.getDisplayName() ) +
'</a></li>\n        ';
 }); ;
__p += '\n    </ul>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/integrations/customJs/lockIcon/CustomJsLockIconList.tpl
// module id = 3068
// module chunks = 0